import { Injectable } from '@angular/core'
import { Rsvp } from '../models/rsvp';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { RsvpHttpService } from './rsvp.http.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { ComparatorUtils } from '../utils/comparator-utils';

@Injectable()
export class RsvpStore {
  private rsvpSubject: ReplaySubject<List<Rsvp>> = new ReplaySubject<List<Rsvp>>(1);

  constructor(private rsvpHttpService: RsvpHttpService,
              private flashMessagesService: FlashMessagesService) {
  }

  get rsvps(): Observable<List<Rsvp>> {
    return this.rsvpSubject.asObservable().map(rsvpList => rsvpList.sort(
      (rsvp1: Rsvp, rsvp2: Rsvp) => ComparatorUtils.compareRsvps(rsvp1, rsvp2)).toList());
  }

  loadRsvps(eventId: number): Observable<List<Rsvp>> {
    return this.rsvpHttpService.getRsvps(eventId)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', `Error getting RSVPs: ${error}`);
        return Observable.throw(error);
      })
      .map(rsvpList => {
        this.rsvpSubject.next(rsvpList);
        return rsvpList;
      })
  }

  get totalNights(): Observable<number> {
    return this.rsvps.map((rsvpList: List<Rsvp>): number => {
      return rsvpList
        .map(rsvp => rsvp.nights)
        .reduce((sum: number, current: number) => !!current ? sum + current : sum, 0);
    });
  }

  get totalRevenue(): Observable<number> {
    return this.rsvps.map(rsvpList => {
      return rsvpList
        .map(rsvp => rsvp.revenue)
        .reduce((sum: number, currentRevenue: number) => !!currentRevenue ? sum + currentRevenue : sum, 0);
    });
  }

  get totalCommission(): Observable<number> {
    return this.rsvps.map(rsvpList => {
      return rsvpList
        .map(rsvp => rsvp.commission)
        .reduce((sum: number, current: number) => !!current ? sum + current : sum, 0);
    });
  }

  addRsvp(rsvp: Rsvp): Observable<any> {
    return this.rsvpHttpService.add(rsvp)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.ADD_RSVP', `Error adding rsvp: ${error}`);
        return Observable.throw(error);
      })
      .map(result => {
        this.flashMessagesService.success('EVENT.RSVPS.RSVP_ADDED');
        this.loadRsvps(rsvp.eventId).subscribe();
        return result;
      });
  }

  importRsvpViaCsv(eventId: number, file: File): Observable<any> {
    return this.rsvpHttpService
      .importRsvpViaCsv(eventId, file)
      .map((importResponse) => {
        this.loadRsvps(eventId).subscribe();
        return importResponse;
      });
  }

  deleteRsvp(rsvp: Rsvp): Observable<any> {
    return this.rsvpHttpService.delete(rsvp)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.DELETE_RSVP', `Error adding rsvp: ${error}`);
        return Observable.throw(error);
      })
      .map(result => {
        this.flashMessagesService.success('EVENT.RSVPS.RSVP_DELETED');
        this.loadRsvps(rsvp.eventId).subscribe();
        return result;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/rsvp.store.ts